var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0.5625H6.50003C4.92531 0.5625 3.41508 1.18806 2.30159 2.30155C1.18809 3.41505 0.562533 4.92528 0.562533 6.5V21.5C0.55663 21.5204 0.55663 21.5421 0.562533 21.5625C0.578996 23.1264 1.21181 24.6206 2.32353 25.7206C3.43525 26.8206 4.93608 27.4376 6.50003 27.4375H21.5C23.0575 27.4344 24.5515 26.8194 25.6598 25.7251C26.7681 24.6308 27.4021 23.1448 27.425 21.5875V6.5C27.425 4.92744 26.8012 3.41911 25.6904 2.30597C24.5796 1.19283 23.0726 0.565811 21.5 0.5625ZM25.5625 19L20.3375 13.025C20.0056 12.6716 19.6047 12.3899 19.1597 12.1974C18.7147 12.0048 18.2349 11.9055 17.75 11.9055C17.2652 11.9055 16.7854 12.0048 16.3404 12.1974C15.8954 12.3899 15.4945 12.6716 15.1625 13.025L11.575 17.125L10.4 15.7C10.0763 15.3116 9.67105 14.9991 9.21311 14.7847C8.75517 14.5702 8.25569 14.4591 7.75003 14.4591C7.24437 14.4591 6.74489 14.5702 6.28695 14.7847C5.82902 14.9991 5.42381 15.3116 5.10003 15.7L2.43753 18.9125V6.5C2.44083 5.42357 2.8699 4.39217 3.63105 3.63102C4.39221 2.86987 5.42361 2.4408 6.50003 2.4375H21.5C22.5765 2.4408 23.6079 2.86987 24.369 3.63102C25.1302 4.39217 25.5592 5.42357 25.5625 6.5V19Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10.25C9.13071 10.25 10.25 9.13071 10.25 7.75C10.25 6.36929 9.13071 5.25 7.75 5.25C6.36929 5.25 5.25 6.36929 5.25 7.75C5.25 9.13071 6.36929 10.25 7.75 10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.31970b2f5f73758cec10001bf991cdef.svg";
export { ForwardRef as ReactComponent };